import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import BoxListing from "./boxListing";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { getWorkspaceId } from "../../store/actions/documentsWithSearch";

const BoxRecentInvoices = ({ invoices, isCentered, title, isGettingObjectiveDeadlines, isGettingLastEInvoices}) => {
  const dispatch = useDispatch();
  const noRecentInvoices = useIntl().formatMessage({ id: "dashboard.noRecentInvoices" });
  const currentCompanyOrAccount = useSelector(state => state.documentsWithSearch.companyWorkspaceId);
  const companies = currentCompanyOrAccount?.companies?.companies;
  const accountants = currentCompanyOrAccount?.companies?.accountants;
  const navigate = useNavigate();
  const goToDocuments = () => {
    navigate({
      pathname: "/documenti",
      state: {
        category: "Fatture ricevute",
        macrocategory: "Fatture",
        sortOnField: "created_on",
        sortOrder: "desc"
      }
    });
  };

  useEffect(()=>{
    dispatch(getWorkspaceId());
  },[]);
   
  return (
    <BoxListing
      getWorkspaceId={companies?.length === 0 ? accountants : companies}
      elements={invoices}
      isCentered={isCentered}
      numElementsDisplayed={4}
      title={title}
      emptyMessage={noRecentInvoices}
      isGettingObjectiveDeadlines={isGettingObjectiveDeadlines}
      isGettingLastEInvoices={isGettingLastEInvoices}      
      showOtherElementsCustomAction={() => goToDocuments()}
    />
  );
};

BoxRecentInvoices.propTypes = {
  categoryId: PropTypes.number,  
  invoices: PropTypes.array,
  isCentered: PropTypes.bool,
  isGettingLastEInvoices: PropTypes.bool,
  isGettingObjectiveDeadlines: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default BoxRecentInvoices;